import Helper from '@ember/component/helper';
import { guidFor } from '@ember/object/internals';

export default class RoleDescriptionHelper extends Helper {
  compute() {
    return guidFor(this);
  }
}
